import styled from '@emotion/styled';
import { ActionButton } from 'ui/components/elements/ActionButton/ActionButton';
import Img01 from 'ui/images/top/topService_img01@2x.png';

const Wrapper = styled.div`
    width: 80svw;
    padding: 30px 20px;
    max-width: 600px;
    border-radius: 20px;
    background: var(--white);
    margin: 10px auto;
    text-align: center;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);

    img {
        width: 170px;
        margin: 0 auto;
    }
`;

const Title = styled.div`
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 20px;
    line-height: 1.5;
`;

const Buttons = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
`;

/**
 * 仲介業者の登録申請フォームを表示するモーダル
 */
export const AgentSignUpRequest: React.FC = () => {
    const handleAgentClick = () => {
        window.open(
            'https://docs.google.com/forms/d/e/1FAIpQLSeXvBU4WdcdMYM8DPo54Obq2J59VlnBuW-w491Ol9-ZuUeV0A/viewform',
            '_blank',
        );
    };

    return (
        <Wrapper>
            <img src={Img01} alt="挿絵" />
            <Title>仲介業者様のご登録には審査が発生します</Title>
            <p style={{ fontSize: '14px', lineHeight: '1.8', marginBottom: '24px' }}>
                ご利用をご希望の方は、以下のフォームよりユーザー登録をお願いいたします。
                <br />
                ご登録後、3営業日～5営業日以内にアカウント情報をメール送いたします。
            </p>
            <Buttons>
                <ActionButton
                    id="agent-signup"
                    bgColor="primary"
                    style={{
                        maxWidth: '90svw',
                        width: '300px',
                        margin: '0 auto',
                    }}
                    onClick={handleAgentClick}
                >
                    申請フォームはこちら
                </ActionButton>
            </Buttons>
        </Wrapper>
    );
};
